import useLoginApi from '../hooks/use.login.api';
import use from '../objects/use';
import useCreateAccountApi from './use.create.account.api';
import useCreateAccountData from './use.create.account.data';
import useFindAccountApi from './use.find.account.api';
import useGlobal from './use.global';
import useUnlockAccountApi from './use.unlock.account.api';
import useUnlockAccountData from './use.unlock.account.data';
import useVerifyAccountApi from './use.verify.account.api';
import { useInflightTracker } from './use.inflight.tracker';

export default function useLoadSharedHooks() {
   use.createAccountApi = useCreateAccountApi();
   use.createAccountData = useCreateAccountData();
   use.global = useGlobal();
   use.loginApi = useLoginApi();
   use.findAccountApi = useFindAccountApi();
   use.inflightTracker = useInflightTracker();
   use.unlockAccountApi = useUnlockAccountApi();
   use.unlockAccountData = useUnlockAccountData();
   use.verifyAccountApi = useVerifyAccountApi();
}